export default class TableMouseEventsHandler {
    constructor(table, selectionController, hoverController) {
        this.table = table;
        this.selectionController = selectionController;
        this.hoverController = hoverController;
        this.selectionAnchor = null;
        this.mouseIsDown = false;
    }

    mouseOver(evt, cell) {
        if (this.mouseIsDown)
            this.selectionController.changeSelectionTo(cell);
        else
            this.hoverController.hover(cell, cell);
    }

    mouseOut(evt, cell) {
        if (!this.mouseIsDown)
            this.hoverController.unhover();
    }

    mouseDown(evt, cell) {
        this.mouseIsDown = true;
        this.selectionController.clearSelection();
        this.selectionController.setSelectionAnchor(cell);
        this.selectionController.changeSelectionTo(cell);
    }

    mouseUp(evt, cell) {
        this.mouseIsDown = false;
    }

    mouseMove(evt, cell) {
        // nothing to do
    }

    contextMenu(evt, cell) {
        // nothing
    }

    getSelectionController() {
        return this.selectionController;
    }

    getHoverController() {
        return this.hoverController;
    }
}


// WEBPACK FOOTER //
// ./web/js/table/TableMouseEventsHandler.js